package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class CategoryEntity(
  public val id: String,
  public val name: String,
  public val isDeleted: Boolean,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
